import { Injectable, signal, WritableSignal } from '@angular/core';
import { MapMarkerComponent } from '../components/map/map-marker/map-marker.component';

@Injectable()
export class MapMarkerInfoWindowService {
  private _openMarkerInfoWindows: WritableSignal<MapMarkerComponent[]> = signal([]);
  openMarkerInfoWindows = this._openMarkerInfoWindows.asReadonly();

  isInfoWindowOpen(markerId: MapMarkerComponent['markerId']) {
    return this.openMarkerInfoWindows().find(marker => marker.markerId === markerId);
  }

  openInfoWindow(marker: MapMarkerComponent, closeOthers = true) {
    if (closeOthers) {
      this.openMarkerInfoWindows().filter(current => current.markerId !== marker.markerId)
        .forEach(m => m.infoWindowClosed.emit());
      this._openMarkerInfoWindows.update(markers => markers.filter(current => current.markerId === marker.markerId));
    }

    if (!this.isInfoWindowOpen(marker.markerId)) {
      marker.infoWindowOpened.emit();
      this._openMarkerInfoWindows.update(markers => [...markers, marker]);
    }
  }

  closeAllInfoWindows() {
    this.openMarkerInfoWindows().forEach(marker => marker.infoWindowClosed.emit());
    this._openMarkerInfoWindows.set([]);
  }

  closeInfoWindow(markerId: MapMarkerComponent['markerId']) {
    const marker = this._openMarkerInfoWindows().find(marker => marker.markerId === markerId);
    marker?.infoWindowClosed.emit();
    this._openMarkerInfoWindows.update(markers => markers.filter(m => m.markerId !== markerId));
  }
}
